<template>
  <div class="app-container">
    <navigation></navigation>
    <div class="main">
      <van-search  placeholder="请输入关键词" @focus="onSearch" center class="serach"/>
      <div v-if="isShow && recommendList.length>0">
        <div class="recommend" v-if="model">
          <h1>热门推荐</h1>
          <div class="recommend-content-list">
            <div class="recommend-content">
              <dl v-for="item in recommendList" @click="goRecommend(item)">
                <dt><img :src="item.coverPath" alt=""></dt>
                <dd>
                  <p class="recommend-name">{{ item.title }}</p>
                </dd>
              </dl>
            </div>
          </div>
        </div>
        <div class="resource" v-else>
          <div class="resource-list" style="background:none">
            <van-cell class="resource-title" center>
              <template #title>
                <span class="model-title">热门推荐</span>
              </template>
              <template #right-icon>
              </template>
            </van-cell>
            <div class="resource-content-list">
              <ul class="list" @scroll="reScroll" ref="relist">
                <li v-for="item in recommendList" @click="goRecommend(item)">
                  <img :src="item.coverPath" alt="">
                  <span class="list-block">
                    <span class="list-overflow">{{ item.title }} </span>
                  </span>
                </li>
              </ul>
            </div>
            <div class="scroll-bar" ref="reScrollBar">
              <div class="bar" ref="reBar"></div>
            </div>
          </div>
        </div>
<!--        <div class="resource">-->
<!--          <div class="resource-list">-->
<!--            <van-cell class="resource-title" center>-->
<!--              <template #title>-->
<!--                <span class="model-title">热门推荐</span>-->
<!--              </template>-->
<!--              <template #right-icon>-->
<!--              </template>-->
<!--            </van-cell>-->
<!--            <div class="resource-content">-->
<!--              <van-cell @click="goRecommend(recommendList[0].link)">-->
<!--                <template #title>-->
<!--                  <img :src="recommendList[0].coverPath" alt="" class="resource-content-img">-->
<!--                </template>-->
<!--                <template #right-icon>-->
<!--                  <div class="resource-content-right">-->
<!--                    <div class="resource-content-title">{{ recommendList[0].title }}</div>-->
<!--                    <div class="resource-content-author">作者：{{recommendList[0].author}}</div>-->
<!--                    <div class="resource-content-descHtml">简介：{{recommendList[0].descHtml}}</div>-->
<!--                  </div>-->
<!--                </template>-->
<!--              </van-cell>-->
<!--            </div>-->
<!--            <div class="resource-content-list">-->
<!--              <ul class="list" @scroll="reScroll" ref="relist">-->
<!--                <li v-for="item in recommendList" @click="goRecommend(item.link)">-->
<!--                  <img :src="item.coverPath" alt="">-->
<!--                  <span class="list-block">-->
<!--                    <span class="list-overflow">{{ item.title }} </span>-->
<!--                  </span>-->
<!--                </li>-->
<!--              </ul>-->
<!--            </div>-->
<!--            <div class="scroll-bar" ref="reScrollBar">-->
<!--              <div class="bar" ref="reBar"></div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="resource">-->
<!--          <div class="resource-list">-->
<!--            <van-cell class="resource-title" center>-->
<!--              <template #title>-->
<!--                <span class="model-title">热门推荐</span>-->
<!--              </template>-->
<!--              <template #right-icon>-->
<!--              </template>-->
<!--            </van-cell>-->
<!--            <div>-->
<!--              <swiper ref="mySwiper" class="swiper-container" :options="swiperOption">-->
<!--                <swiper-slide class="swiper-slide" v-for="item in recommendList">-->
<!--                  <div>-->
<!--                    <img class="swiper-slide-img" :src="item.coverPath" />-->
<!--                    <div class="swiper-slide-title">{{ item.title }} </div>-->
<!--                  </div>-->
<!--                </swiper-slide>-->
<!--                <div class="swiper-pagination" slot="pagination"></div>-->
<!--              </swiper>-->
<!--            </div>-->
<!--            <div class="resource-swiper-content">-->
<!--              <div class="swiper-title" v-if="recommendList[swiperIndex].title">{{ recommendList[swiperIndex].title }}</div>-->
<!--              <div class="swiper-author" v-if="recommendList[swiperIndex].author">作者：{{ recommendList[swiperIndex].author }}</div>-->
<!--              <div class="swiper-descHtml" v-if="recommendList[swiperIndex].descHtml">图书简介：{{ recommendList[swiperIndex].descHtml }}</div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
      </div>
      <div class="platform">
        <h1>更多资源</h1>
        <div class="platform-content">
          <dl v-for="item in showList" @click="goPlatform(item.link,item.loginType,item.id,item.title)">
            <dt><img :src="baseUrl+item.coverPath" alt=""></dt>
            <dd>{{item.title}}</dd>
          </dl>
        </div>
      </div>
      <div class="praise-book" v-if="isPraise">
        <div class="recommend">
          <h1 class="praise-title-name">口碑好书</h1>
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
            class="praise-list"
          >
            <van-cell v-for="item in praiseList" @click="goRecommend(item)">
              <template #title>
                <img :src="item.coverPath" alt="" class="praise-img">
              </template>
              <template #right-icon>
                <div class="praise-right">
                  <div class="praise-title">{{ item.title }}</div>
                  <div class="praise-author" v-if="item.author">作者：{{ item.author }}</div>
                  <div class="praise-html" v-if="item.descHtml">简介：{{ item.descHtml }}</div>
                </div>
              </template>
            </van-cell>
          </van-list>
        </div>
      </div>
    </div>
    <van-tabbar v-model="active" class="resource-tab" ref="tab">
      <van-tabbar-item to="/">
        <span>首页</span>
        <template #icon="props">
          <span class="tabbar-bg"></span>
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="resource">
        <span>资源</span>
        <template #icon="props">
          <span class="tabbar-bg"></span>
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="information">
        <span>资讯</span>
        <template #icon="props">
          <span class="tabbar-bg"></span>
        </template>
      </van-tabbar-item>
      <van-tabbar-item  to="personal">
        <span>个人中心</span>
        <template #icon="props">
          <span class="tabbar-bg"></span>
        </template>
      </van-tabbar-item>
    </van-tabbar>
    <version></version>
  </div>
</template>

<script>
import Vue from 'vue'
import {Tabbar, TabbarItem, NavBar, Cell, CellGroup, Tab, Tabs, Dialog} from 'vant'
import {request} from '../../untils/request'
import navigation from '../../components/navigation'
import version from '../../components/version'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'vue-awesome-swiper/node_modules/swiper/dist/css/swiper.css'

Vue.use(Tabbar).use(TabbarItem).use(NavBar).use(Cell).use(CellGroup).use(Tab).use(Tabs)

export default {
  name: 'resource',
  components: {navigation,version, swiper, swiperSlide},
  data () {
    return {
      baseUrl: process.env.API_ROOT,
      active: 1,
      showAll: false,
      list: [],
      loading: false,
      finished: false,
      platform: [],
      recommendList: [],
      params: {
        pageNum: '1',
        pageSize: '4'
      },
      model: true,
      isShow: true,
      isPraise: true,
      praiseList: [],
      praiseModel: true,
      swiperIndex: 0,
      swiperOption: {
        //可见图片张数
        slidesPerView: 3,
        // 默认选中中间一张
        centeredSlides: true,
        //无限循环
        loop: true,
        //小圆点（我此处没使用，列出供参考）
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        spaceBetween: 30, // 在slide之间设置距离 也可以是百分比 10%
        on: {
          slideChange:() => {
            this.swiperIndex = this.$refs.mySwiper.swiper.realIndex
          }
        }
      },
    }
  },
  created () {
    // 推荐列表
    this.getRecommend()
    // 更多资源平台
    this.getResourceRead()
    // 资源推荐模版
    this.getModel()
    // 口碑好书模版
    this.getPraiseModel ()
    window.scrollTo(0,0);
  },
  computed: {
    showList: function () {
      if (!this.showAll) {
        var showList = []
        if (this.platform.length > 8) {
          for (var i = 0; i < 8; i++) {
            showList.push(this.platform[i])
          }
        } else {
          showList = this.platform
        }
        return showList
      } else {
        return this.platform
      }
    }
  },
  mounted() {
    this.isIPhoneX()
  },
  methods: {
    // 口碑好书
    onLoad() {
      this.params.type = 'PRAISE'
      request('get', '/nlc-web/api/resourceRead/recommend',this.params).then(res => {
        console.log('推荐列表', res)
        res.data.content.forEach(item=>{
          if(item.coverPath) {
            if(item.coverPath.substr(0,7).toLowerCase() === "http://" || item.coverPath.substr(0,8).toLowerCase() === "https://"){
              item.coverPath = item.coverPath;
            }else{
              item.coverPath = this.baseUrl + item.coverPath;
            }
          }
          this.praiseList.push(item)
        })
        if(this.praiseList.length>0){
          this.isPraise = true
        } else {
          this.isPraise = false
        }
        // 加载状态结束
        this.loading = false;
        // 数据全部加载完成
        if (res.data.totalElements === this.praiseList.length) {
          this.finished = true;
        }
      })
      this.params.pageNum++
    },
    // 搜索
    onSearch () {
      this.$router.push({name: 'search',params:{'active': 1}})
    },
    // 热门推荐
    getRecommend () {
      let params = {
        type: 'HOT'
      }
      request('get', '/nlc-web/api/resourceRead/recommend',params).then(res => {
        console.log('推荐列表', res)
        this.isShow = res.show
        res.data.content.forEach(item=>{
          if(item.coverPath) {
            if(item.coverPath.substr(0,7).toLowerCase() === "http://" || item.coverPath.substr(0,8).toLowerCase() === "https://"){
              item.coverPath = item.coverPath;
            }else{
              item.coverPath = this.baseUrl + item.coverPath;
            }
          }
        })
        this.recommendList = res.data.content
      })
    },
    getResourceRead () {
      request('get', '/nlc-web/api/resourceRead').then(res => {
        console.log('更多资源平台', res)
        this.platform = res.data.content
      })
    },
    // 推荐资源跳转
    goRecommend (e) {
      let params = {
        resId: e.id,
        resName: e.title,
        moduleName: '资源阅读'
      }
      request('post', '/nlc-web/api/websiteData/res',params).then(res => {
        console.log('统计',res)
      })
      let newStr = e.link.indexOf('http')
      if (newStr === 0) {
        window.open(e.link)
      } else {
        var src = process.env.API_ROOT + e.link
        window.open(src)
      }
    },
    // 更多资源平台点击
    goPlatform (link, type, resId, resName) {
      let tag = this.GetQueryString('tag')
      if(tag==='3d32f4b0'){
        if (resName==='畅想之星') {
          this.saveTj(resId, resName)
          window.open('https://www.cxstar.com/')
        } else {
          this.saveTj(resId, resName)
          window.open(link)
        }
      } else {
        if (type === 'READER_CARD') {
          // 读者卡
          this.login(this.$store.state.rcardId, link ,'请用读者卡登录？', resId, resName)
        } else if (type === 'NLC_ACCOUNT') {
          // 账户登陆
          this.login(this.$store.state.uid, link ,'请用账户登录？', resId, resName)
        } else if (type === 'REAL_NAME') {
          // 实名用户
          this.login(this.$store.state.idno, link ,'请用实名用户登录？', resId, resName)
        } else {
          this.saveTj(resId, resName)
          window.open(link)
        }
      }
    },
    saveTj(resId, resName) {
      let params = {
        resId: resId,
        resName: resName,
        moduleName: '资源库'
      }
      request('post', '/nlc-web/api/websiteData/res',params).then(res => {
        console.log('统计',res)
      })
    },
    // 登陆条件判断
    login  (id, link, messgae, resId, resName) {
      if (id) {
        this.saveTj(resId, resName)
        window.open(link)
      } else {
        Dialog.confirm({
          message: messgae
        }).then(() => {
          let url = encodeURI(window.location.href)
          window.location.href = process.env.API_ROOT + '/nlc-api/api/nlc/login?paramUrl='+url
        }).catch(() => {
          // on cancel
        })
      }
    },
    // 获取滚动条距离资源阅读
    reScroll  (event) {
      let barSCrollWidth = this.$refs.reScrollBar.clientWidth + this.$refs.reBar.clientWidth // 自定义滑条可移动范围
      let left = event.target.scrollLeft * barSCrollWidth / event.target.scrollWidth
      if(left > 86){
        this.$refs.reBar.style.marginLeft = `${86}%`
      } else if(left < 0){
        this.$refs.reBar.style.marginLeft = `${0}%`
      } else {
        this.$refs.reBar.style.marginLeft = `${left}%`
      }
    },
    // 获取滚动条距离口碑好书
    scroll  (event) {
      let barSCrollWidth = this.$refs.scrollBar.clientWidth + this.$refs.bar.clientWidth // 自定义滑条可移动范围
      let left = event.target.scrollLeft * barSCrollWidth / event.target.scrollWidth
      if(left > 86){
        this.$refs.bar.style.marginLeft = `${86}%`
      } else if(left < 0){
        this.$refs.bar.style.marginLeft = `${0}%`
      } else {
        this.$refs.bar.style.marginLeft = `${left}%`
      }
    },
    // 获取资源推荐模版
    getModel () {
      let params = {
        type: 'RECOMMEND_BOOK_SHOW'
      }
      request('get', '/nlc-web/api/bookRecommend/showStyle',params).then(res => {
        console.log('资源推荐模版', res)
        if(res.data.dictValue === 'VERTICAL_PLATE'){
          // 竖版
          this.model = false
        } else {
          // 横版
          this.model = true
        }
      })
    },
    // 获取口碑好书模版
    getPraiseModel () {
      let params = {
        type: 'PRAISE_BOOK_SHOW'
      }
      request('get', '/nlc-web/api/bookRecommend/showStyle',params).then(res => {
        console.log('口碑好书模版', res)
        if(res.data.dictValue === 'VERTICAL_PLATE'){
          // 竖版
          this.praiseModel = false
        } else {
          // 横版
          this.praiseModel = true
        }
      })
    },
    // 判断手机是否为iphonex
    isIPhoneX() {
      let u = navigator.userAgent;
      let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isIOS) {
        if (screen.height >= 812) {
          //是iphoneX
          console.log('this.$refs.tab.style',this.$refs.tab)
          this.$refs.tab.$el.style.paddingBottom = `${.2}rem`
        }
      }
    },
    // 获取地址栏参数
    GetQueryString(name) {
      var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if(r!=null)return  unescape(r[2]); return null;
    },
  }
}
</script>

<style scoped>
.app-container{
  background:#ecf5fd;
  padding-bottom:1.3rem;
  overflow-y:scroll;
  min-height:calc(100% - 2.02rem);
}
.main{
  margin-top:1.09rem;
}
.serach input{
  font-family: SourceHanSansCN-Normal;
}
.van-search{
  width: 6.94rem;
  height: .86rem;
  border-radius: 40px;
  margin-left:.28rem;
}
.van-search .van-cell{
  padding:0;
}
.van-search__content{
  background:#fff;
}
.recommend{
  width:6.94rem;
  margin:0 .28rem;
  background:#fff;
  border-radius:8px;
}
h1{
  font-size:.36rem;
  color:#444649;
  padding:.25rem 0 .3rem .27rem;
  font-family: SourceHanSerifCN-SemiBold;
  margin:.16rem 0 0 0;
}
.recommend-content-list{
  overflow:hidden;
  height:3rem;
  padding:0 .3rem .2rem .3rem;
}
.recommend-content{
  height:3.4rem;
  overflow-y:scroll;
  display: flex;
}
.recommend-content dl{
  width:2.28rem;
  height:3.2rem;
  margin:0;
  display: block;
  margin:0 .24rem 0 0;
}
.recommend-content dt img{
  width:2.28rem;
  height:1.88rem;
  box-shadow: 6px 4px 10px -6px #000;
}
.recommend-content dd{
  margin:0;
}
.recommend-name{
  margin:0;
  font-size:.28rem;
  font-family: SourceHanSerifCN-Regular;
  color: #444649;
  text-align:center;
  width:2.28rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.recommend-author{
  padding-top:.16rem;
}
.recommend-author,.recommend-published{
  line-height:.35rem;
}
.platform{
  width:6.94rem;
  background:#fff;
  border-radius:8px;
  margin:.16rem .28rem 0 .28rem;
  font-size:.26rem;
}
.platform h1{
  padding-left:.27rem;
}
.platform-content{
  width:6.94rem;
  overflow:hidden;
}
.platform-content dl{
  width:1.73rem;
  height:1.45rem;
  float:left;
}
.platform-content dt{
  width:.9rem;
  height:.9rem;
  margin-left:.42rem;
  border-radius:50%;
}
.platform-content dt img{
  width:100%;
  height:100%;
}
.platform-content dl dd{
  text-align:center;
  margin:0;
  color:#444649;
  font-family: SourceHanSerifCN-Regular;
}
.showAll{
  width: 100%;
  line-height:.8rem;
  text-align:center;
}
.tab{
  width:6.34rem;
  margin:0 .28rem .2rem;
  background:#fff;
  border-radius:8px;
  padding:0 .3rem;
}
.arrow{
  position:absolute;
  bottom:.36rem;
}
.list-img{
  width:1.7rem;
  height:2.4rem;
  margin-right:.26rem;
  box-shadow: 6px 4px 10px -6px #000;
}
.van-cell{
  padding:10px 0;
}
.van-cell::after{
  border-bottom: 1px solid #B3BBC3;
  left:0;
  right:0;
}
>>>.van-tabbar-item__icon img{
  width:.56rem;
  height:.56rem;
}
>>>.van-tabbar-item__text{
  font-size:.2rem;
}
>>>.van-tabbar{
  height:1.1rem;
}
.tabbar-bg{
  width:.56rem;
  height:.56rem;
  display:inline-block;
}
>>>.van-tabbar-item__text{
  font-size:.2rem;
  font-family: SourceHanSerifCN-Medium;
}
.resource{
  width: 6.34rem;
  margin: .2rem .28rem 0 .28rem;
  background:#fff;
  border-radius:8px;
  padding: 0 .3rem .2rem .3rem;
}
.resource-list{
  width:100%;
  background-size:100%;
}
.resource-title{
  background:none;
  padding:.25rem 0 .1rem 0;
}
.resource-content-list{
  width:6.34rem;
  height:3.9rem;
  overflow:hidden;
}
.list{
  margin:.15rem 0 0 0;
  padding-bottom:.3rem;
  display:flex;
  font-size:.3rem;
  color:#444649;
  overflow-x:scroll;
  font-family: SourceHanSerifCN-Regular;
}
.list li{
  width:1.8rem;
  margin:0 .185rem;
  text-align:center;
}
.list li:first-child{
  margin-left:0;
}
.list li:last-child{
  margin-right:0;
}
.list li img{
  width:2rem;
  height:2.66rem;
  box-shadow: 6px 4px 10px -6px #00000080;
  margin-bottom:.11rem;
}
.list li .list-block{
  width:1.8rem;
  display:block;
}
.list li .list-overflow{
  width:1.8rem;
  margin-left: .1rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.scroll-bar {
  width:6.2rem;
  height:.08rem;
  background: #E6EFF7;
  border-radius: 8px;
  margin-top:.1rem;
}
.bar{
  width:.88rem;
  height:.08rem;
  border-radius: 8px;
}
.van-cell::after{
  border:0 !important;
}
.model-title{
  font-family: SourceHanSerifCN-SemiBold;
  font-size: .36rem;
  color: #444649;
  font-weight:bold;
}
>>>.van-field__control{
  font-size:.28rem;
  line-height:.42rem;
}
>>>.van-icon-search{
  font-size:.32rem !important;
}
.praise-list{
  min-height:100%
}
.praise-list >>>.van-cell{
  width:6rem;
  height:2.4rem;
  background: linear-gradient(180deg, #ECF5FD 0%, #F7FBFF 100%);
  box-shadow: 0px 48px 120px -36px rgba(67, 70, 73, 0.2);
  border-radius: 8px;
  margin-left:.66rem;
  position:relative;
  overflow: visible;
  margin-top:.56rem;
}
.praise-list >>>.van-cell__title{
  position:absolute;
  left:-.36rem;
  top:-.32rem;
}
.praise-img{
  width:1.7rem;
  height:2.39rem;
  border-radius:8px;
}
.praise-right{
  margin-left: 1.66rem;
  padding-right: .25rem;
}
.praise-title{
  font-size:.32rem;
  font-weight: bold;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
.praise-author{
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
.praise-author,.praise-html{
  font-size:.24rem;
}
.praise-html{
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.resource-content{
  width:6.34rem;
  height:3rem;
  margin-bottom:.55rem;
}
.resource-content >>>.van-cell{
  background:#ECF5FD !important;
  box-shadow: 0px 60px 150px -45px rgba(67, 70, 73, 0.4);
  border-radius: 8px;
  padding: .3rem .37rem .3rem .18rem;
  width: 6.34rem;
}
.resource-content-img{
  width:2rem;
  height:2.66rem;
}
.resource-content-right{
  margin-left:.3rem;
  width:63%;
  line-height:.5rem;
}
.resource-content-title{
  font-size:.32rem;
  font-weight: bold;
  color: #444649;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.resource-content-author{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-top:.16rem;
}
.resource-content-descHtml{
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}
.swiper-slide-img{
  width:1.73rem;
  height:2.4rem;
}
.swiper-slide-title{
  font-size:.28rem;
  width:1.7rem;
  overflow:hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.swiper-container {
  width: 100%;
  height: 3.6rem;
  border-bottom: 1px solid #ECF5FD;
}
.swiper-slide {
  text-align: center;
  font-size: 18px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  transition: 300ms;
  transform: scale(0.8);
}
.swiper-slide-active,.swiper-slide-duplicate-active{
  transform: scale(1) !important;
}
>>>.swiper-pagination-bullet-active{
  background: rgba(0, 128, 149, 0.8) !important;
}
>>>.swiper-pagination-bullet {
  width: .08rem !important;
  height: .08rem !important;
}
>>>.swiper-container-horizontal > .swiper-pagination-bullets {
  bottom: -13px !important;
  padding-bottom: .2rem !important;
}
.resource-swiper-content{
  width:100%;
  margin-top:.22rem;
  line-height:.5rem;
}
.swiper-title{
  font-size:.32rem;
  overflow:hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.swiper-author {
  font-size:.28rem;
  overflow:hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.swiper-descHtml{
  font-size:.28rem;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  overflow: hidden;
}
.van-cell{
  line-height: normal;
}
</style>



// WEBPACK FOOTER //
// src/view/resource/index.vue